import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, OnInit, inject } from '@angular/core';
import * as lodash from 'lodash';
import { interval, merge, Observable, of, Subject } from 'rxjs';
import { catchError, concatMap, delay, take, takeUntil } from 'rxjs/operators';
import { ModalContext } from '../../modal/modal-context';

export enum ResultStatus {
  Success = 'Success',
  Cancel = 'Cancel',
  Error = 'Error',
}

@Component({
  selector: 'app-upload-uploading-modal',
  templateUrl: './upload-uploading-modal.component.html',
  styleUrls: ['./upload-uploading-modal.component.scss'],
  standalone: false,
})
export class UploadUploadingModalComponent implements OnInit {
  private readonly modalContext = inject<
    ModalContext<
      {
        type: ResultStatus;
      },
      {
        response$: Observable<HttpEvent<Blob>>;
      }
    >
  >(ModalContext);

  /** キャンセルを通知する Subject */
  private readonly cancel = new Subject<{ type: ResultStatus.Cancel }>();

  /** 中断時を通知する Subject */
  private readonly abort = new Subject<void>();

  /** アップロードの進捗率 (%) */
  progress = 0;

  ngOnInit() {
    const { response$ } = this.modalContext.data;

    /**
     * プログレスバーの進捗はとりあえず適当な数値を一定間隔でインクリメントしていく
     * @todo 正式なやり方が決まったらこの部分は削除される
     */
    interval(800)
      .pipe(
        take(4),
        concatMap(() => of(true).pipe(delay(300 - lodash.random(-100, 100)))),
      )
      .subscribe(() => {
        const amount = lodash.clamp(this.progress + 20 + lodash.random(-8, 8), 80);
        this.progress = this.progress === 100 ? this.progress : amount;
      });

    merge(response$, this.cancel)
      .pipe(
        takeUntil(this.abort),
        catchError((err) => of({ type: ResultStatus.Error, messages: err.error.messages })),
      )
      .subscribe((result) => {
        // progress がこの API で動けばそのまま使えるかも…?
        // 参考になるかもしれないのでコメントアウトして残しておく
        // if (result.type === HttpEventType.UploadProgress) {
        //   this.progress = result.loaded / result.total * 100;
        // }

        if (result.type === HttpEventType.Response) {
          this.progress = 100;

          // バーが最後まで到達後少し表示をキープしてから閉じる。待ち時間は適当
          setTimeout(() => this.modalContext.close({ type: ResultStatus.Success }), 800);
        }

        if (result.type === ResultStatus.Cancel || result.type === ResultStatus.Error) {
          this.modalContext.close(result);
        }
      });
  }

  /**
   * キャンセルボタン押下時の処理
   */
  onCancel() {
    this.cancel.next({ type: ResultStatus.Cancel });
    this.cancel.complete();

    this.abort.next();
    this.abort.complete();
  }
}
